import React, { useMemo } from 'react';
import styles from './styles/infobar.module.css';
import { RegularButton } from '../button/regular-button';
export const InfobarActions = ({
  invert,
  action: MainButtonProps,
  secondaryAction: SecondaryButtonProps
}) => {
  const renderSecondaryButton = useMemo(() => {
    if (!SecondaryButtonProps || Object.keys(SecondaryButtonProps).length === 0) return null;
    return /*#__PURE__*/React.createElement(RegularButton, {
      ...SecondaryButtonProps,
      size: "s",
      variant: "pseudo",
      invert: invert,
      "data-testid": "infobar-actions-secondary-button"
    });
  }, [SecondaryButtonProps, invert]);
  const renderMainButton = useMemo(() => {
    if (!MainButtonProps || Object.keys(MainButtonProps).length === 0) return null;
    return /*#__PURE__*/React.createElement(RegularButton, {
      variant: "pseudo",
      ...MainButtonProps,
      size: "s",
      invert: invert,
      "data-testid": "infobar-actions-main-button"
    });
  }, [MainButtonProps, invert]);
  const needRenderActionButtons = MainButtonProps || SecondaryButtonProps;
  if (!needRenderActionButtons) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.actions,
    "data-testid": "infobar-actions"
  }, renderSecondaryButton, renderMainButton);
};